import script from "./Alert.vue?vue&type=script&setup=true&lang=ts"
export * from "./Alert.vue?vue&type=script&setup=true&lang=ts"

import "./Alert.vue?vue&type=style&index=0&id=2a6419f9&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a6419f9"]])

export default __exports__